import Imagen from '../img/logo.png';
import fondo from '../img/fondo.jpeg';

export function Footer() {
  const email = 'mailto:nelsonmendozacoach@gmail.com'
  const whatsapp = 'https://wa.me/573022371402';
  return (
    <div style={{ backgroundImage: `url(${fondo})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'  }} >
      <div className=" mx-auto px-4 md:px-8 inset-0 bg-black/50 w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-6">
          <div className='flex flex-col items-center justify-center'>
            <img className='max-h-36 px-6 w-auto' src={Imagen} alt='logo' />
          </div>
          <div className='text-center flex flex-col items-center justify-center'>
            <ul className='text-slate-100 drop-shadow-lg font-times font-bold'>
              <li>El crecimiento no es casualidad. Es dirección estratégica</li>
              <li>Las personas y organizaciones que evolucionan no esperan resultados diferentes haciendo lo mismo.</li>
              <li>Intervienen la raíz del problema, alinean mentalidad con ejecución y construyen sistemas de alto rendimiento.</li>
              <li>No trabajamos sobre síntomas.<br/>Trabajamos sobre la estructura que sostiene tus resultados.</li>
              <li>Si estás listo para operar en un nivel superior, el siguiente paso es una conversación estratégica.</li>
            </ul>
          </div>
          <div className='px-5 flex flex-col items-center justify-center'>
            <ul className='text-slate-100 font-medium font-times'>
              <li><a href={whatsapp}>Contacto +57 302 237 1402</a></li>
              <li>Correo: <a href={email}>nelsonmendozacoach@gmail.com</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}